(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-bundle-products"] && !Shopify.designMode) return;
  try {
    function bundleCarouselScroll(sectionId, direction) {
    var carousel = document.querySelector(
      '#bundle-products-' + sectionId + ' .bundle-products__carousel'
    );
    if (!carousel) return;
    var cardWidth = carousel.querySelector('.bundle-products__card').offsetWidth + 16;
    carousel.scrollBy({ left: direction * cardWidth * 2, behavior: 'smooth' });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hh-precio-promo"] && !Shopify.designMode) return;
  try {
    /*
   * HH · Precio con descuento: cambia el precio y la etiqueta a la hora exacta en que empieza o
   * termina una promoción. No revisa cada segundo: espera hasta el próximo cambio (y mira de
   * nuevo cada minuto por si llegaron precios nuevos a la página, por ejemplo al cambiar de variante).
   */
  (() => {
    if (window.hhPrecioPromo) return;
    window.hhPrecioPromo = true;

    let timer = 0;

    const update = () => {
      window.clearTimeout(timer);
      const now = Date.now() / 1000;
      let next = now + 60;

      for (const promo of document.querySelectorAll('.hh-promo')) {
        const options = promo.querySelectorAll(':scope > [data-hh-pct]');
        let best = null;
        let bestPct = 0;

        for (const option of options) {
          const start = Number(option.getAttribute('data-hh-start')) || 0;
          const end = Number(option.getAttribute('data-hh-end')) || 0;
          const pct = Number(option.getAttribute('data-hh-pct')) || 0;
          if (start > now) {
            next = Math.min(next, start);
          } else if (!end || end > now) {
            if (end) next = Math.min(next, end);
            if (pct > bestPct) {
              best = option;
              bestPct = pct;
            }
          }
        }

        for (const option of options) {
          if (option.hidden !== (option !== best)) option.hidden = option !== best;
        }
        const regular = promo.querySelector(':scope > .hh-promo__regular');
        if (regular && regular.hidden !== (best !== null)) regular.hidden = best !== null;
      }

      timer = window.setTimeout(update, Math.max(next - now, 0) * 1000 + 200);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', update, { once: true });
    } else {
      update();
    }
    window.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') update();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
